import { render, staticRenderFns } from "./IconAgreement.vue?vue&type=template&id=1347106e&"
import script from "./IconAgreement.vue?vue&type=script&lang=js&"
export * from "./IconAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports